import { useState } from 'react';
import serviceimg from '../../../assets/images/SServices.png';
import dossier from "../../../assets/images/Diagram-d.png";
import PageHeader from '@/components/PageHeader';

// Import your tab content components
import USANDApage from './USANDApage';
import EUMAApage from './EUMAApage';
import ASEANCTDpage from './ASEANCTDpage';
import CTDDossierpage from './CTDDossierpage';

function DossierManagement() {
  const [activeTab, setActiveTab] = useState("US-ANDA");

  const tabs = [
    { id: "US-ANDA", label: "US-ANDA" },
    { id: "EU-MAA", label: "EU-MAA" },
    { id: "ASEAN-CTD", label: "ASEAN-CTD" },
    { id: "CTDDossierpage", label: "CTD Dossier" },

  ];

  const renderContent = () => {
    switch (activeTab) {
      case "US-ANDA":
        return <USANDApage />;
      case "EU-MAA":
        return <EUMAApage />;
      case "ASEAN-CTD":
        return <ASEANCTDpage />;
      case "CTDDossierpage":
        return <CTDDossierpage />;
      default:
        return null;
    }
  };

  return (
    <div className="font-sans">

      <PageHeader title='Our Services' imageUrl={serviceimg} breadcrumbs={['Home', 'Our Services', 'Regulatory Services', 'Dossier Management']} />

      {/* <div className="lg:w-4xl pl-4 pr-12 py-12 mb-12 sm:pl-6 sm:pr-20 lg:pr-32 ml-0 lg:ml-48">
        <h2 className="text-2xl font-bold text-[#05326D] flex items-center gap-2 mb-8">
          <span className="inline-block w-2 h-6 rounded-sm bg-[#B5AB28]"></span>
          Regulatory Services
        </h2> */}

      <div className="max-w-[var(--max-width)] mx-auto px-4 sm:px-6 md:px-12 lg:px-20 xl:px-32 py-12 text-[#05326D]">

        <h2 className="text-xl font-bold text-[#05326D] flex items-center gap-2 mb-12">
          <span className="inline-block w-[6px] h-5 rounded-tr-sm rounded-br-sm bg-[#B5AB28]"></span>
          Regulatory Services
        </h2>

        <div className="flex items-center gap-2 mb-2 mt-8">
          <span className="w-4 h-4 rounded-full bg-sky-400 flex-shrink-0"></span>
          <h3 className="text-lg font-semibold text-[#05326D]">
            Dossier Management
          </h3>
        </div>
        <img src={dossier} alt="Service" className="w-full h-auto my-6 rounded-md" />


        <hr className="border-t border-gray-300 mb-12" />

        <div className="flex space-x-10 border-b border-gray-300 mb-6">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              className={`relative pb-2 font-semibold ${activeTab === tab.id ? 'text-[#05326D]' : 'text-gray-600'
                }`}
              onClick={() => setActiveTab(tab.id)}
            >
              {tab.label}
              {activeTab === tab.id && (
                <span className="absolute left-0 -bottom-[2px] h-[3px] w-full bg-[#B5AB28]" />
              )}
            </button>
          ))}
        </div>

        {renderContent()}
      </div>
    </div>
  );
}

export default DossierManagement;
